import * as React from 'react';
import b_ from 'b_';
import translate, { InjectedTranslateProps } from 'shared/utils/translate';
import { AmountInput } from 'shared/components/AmountInput';

import './index.scss';

interface Props {
  name: string;
}

const parseNumber = (val: string) => Math.max(parseInt(val, 10) || 0, 0) || '';

type Enhanced = Props & InjectedTranslateProps;

const b = b_.with('stock-submit-amount-input');

export const StockSubmitSection: React.FC<Enhanced> = ({ t, name }) => (
  <AmountInput
    name={name}
    parse={parseNumber}
    label={t('Quantity of stocks')}
    placeholder="0"
    className={b()}
    classNameInput={b('input')}
    classNameLabel={b('label')}
  />
);

export default translate(StockSubmitSection);
